/**
 * Converts a backend name ("User Management", "user-management", "user_management")
 * to the snake_case segment used in the `roles.*` translation keys.
 */
export function toRoleTranslationSegment(name: string | null | undefined): string {
  return (name ?? '')
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

/** Human readable label for a snake_case name when no translation exists. */
export function humanizeRoleName(name: string | null | undefined): string {
  const words = (name ?? '').trim().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : '';
}

/**
 * Returns the translation, or the fallback when the translate pipe returned the key itself
 * (meaning no translation exists). A raw translation key is never returned.
 */
export function roleLabelOrFallback(translated: string, key: string, fallback: string): string {
  return translated && translated !== key ? translated : fallback;
}
